import React, { useEffect, useState } from 'react';

import { DatasourceModel, WidgetTableColumnsData } from 'jamespot-user-api';

import { ExcelEditorSpreadSheets } from './ExcelEditorSpreadSheets';
import { ExcelEditorModel } from './ExcelEditorModel';
import { ExcelEditorUploader } from './ExcelEditorUploader';
import { ExcelEditorSelectDocument } from './ExcelEditorSelectDocument';
import { ExcelEditorSelectWedocFile } from './ExcelEditorSelectWedocFile';

import { useEditorContext } from 'components/Widgets/context/hooks';
import { WidgetExcelDatasourceContext } from '../../JRCWidgetExcelDatasourceTableEditor';

export const ExcelEditor = ({ uri, tableColumnsData }: { uri?: string; tableColumnsData: WidgetTableColumnsData }) => {
    const [token, setToken] = useState<string | undefined>(undefined);
    const [model, setModel] = useState<DatasourceModel | undefined>(undefined);
    const [tmpUri, setTmpUri] = useState<string | undefined>(undefined);
    const enableAttachment = false;

    const { hook, handlers } = useEditorContext<WidgetExcelDatasourceContext>();

    useEffect(() => {
        if (!uri && tableColumnsData.length === 0 && !token) {
            handlers.handleStart();
            handlers.jamespot.network
                .token()
                .then((response) => setToken(response.result))
                .catch(handlers.handleCatch)
                .finally(handlers.handleFinally);
        }
    }, [uri, tableColumnsData, handlers, token]);

    useEffect(() => {
        if (uri && !model) {
            handlers.handleStart();
            handlers.jamespot.datasource
                .getModel(uri)
                .then((response) => {
                    setModel(response.result.model);
                    setTmpUri(undefined);
                })
                .catch(handlers.handleCatch)
                .finally(handlers.handleFinally);
        }
    }, [tableColumnsData, uri, model, handlers]);

    const onHandleCancel = () => {
        setTmpUri(undefined);
        handlers.handleStart();
        handlers.jamespot.network
            .token()
            .then((response) => setToken(response.result))
            .catch(handlers.handleCatch)
            .finally(handlers.handleFinally);
    };

    useEffect(() => {
        if (!uri) {
            setModel(undefined);
            setTmpUri(undefined);
        }
    }, [uri]);

    return (
        <>
            {!uri && !tmpUri && token !== undefined && (
                <>
                    <ExcelEditorUploader token={token} onCreateSuccess={setTmpUri} />
                    {hook && hook.isActive('FileBankHook') && enableAttachment && (
                        <ExcelEditorSelectDocument onCreateSuccess={setTmpUri} />
                    )}
                    {hook && hook.isActive('WeDocHook') && enableAttachment && (
                        <ExcelEditorSelectWedocFile onCreateSuccess={setTmpUri} />
                    )}
                </>
            )}
            {!uri && tmpUri && tableColumnsData.length === 0 && (
                <ExcelEditorSpreadSheets uri={tmpUri} onHandleCancel={onHandleCancel} />
            )}
            {uri && model ? <ExcelEditorModel uri={uri} model={model} tableColumnsData={tableColumnsData} /> : <></>}
        </>
    );
};
